import React, { useCallback, useMemo, useState } from 'react'
import { Row, Col, Label, Input, Pagination, Table, PaginationItem, PaginationLink, Button } from "reactstrap"
import { AtenderSolicitudReverso, DetalleProyeccion, ESTADO_ENVIADO_A_TH, ESTADO_REVERSADO_TH, ESTADO_SOLICITADO_REVERSO_A_TH, ProyeccionTotal, ReversarUnidadProyeccionHEDTO, UnidadesProyeccion } from './TypesProyecionHorasExtrasAdmin'
import { RegimenLaboralHEDTO } from 'components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE'
import { ReactComponent as IconoReversar } from "../../../../assets/icons/HorasExtras/Reversar.svg"
import { ReactComponent as IconoNotificacion } from "../../../../assets/icons/HorasExtras/Notificacion.svg"
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import { showAlert, showAlertAviso } from '../Parametros Horas Extras/Actividades/ActividadesHorasExtras'
import { ReactComponent as IconoImprimir } from "../../../../assets/icons/HorasExtras/Imprimir.svg"
import { ReactComponent as IconoExcel } from "../../../../assets/icons/HorasExtras/Excel.svg"
import { EnviarProyeccionesUnidadesAGPE, ObtenerReporteExcelProyeccionesUnidadesTH, ObtenerReporteProyeccionesUnidadesTH, PutAtenderSolicituReverso, ReversarUnidadDesdeTH } from './FunctionsProyeccionHorasExtras'
import ModalCargando from 'components/Varios/ModalCargando'
import ModalReversarUnidad from './ModalReversarUnidad'
import ModalReversoHE from 'components/Varios/Modals/ModalReversoHE'

import Swal from 'sweetalert2'
import NumberFormat from 'react-number-format'


type StateModalReversoUnidades = {
    showModal: boolean,
    cargando: boolean,
    planificacionUnidad: UnidadesProyeccion[],
    observacion: string
    content: JSX.Element
};

type PropsTablaUnidadesProyeccionHE = {
    selectedUnidades: UnidadesProyeccion[],
    regimendisponible: RegimenLaboralHEDTO[],
    detalleProyeccion: DetalleProyeccion,
    totalProyeccion: ProyeccionTotal | null
    anioInformacionProyeccion: number,
    onActualizarTabla: () => Promise<void>,
    defaultRowNumber?: number
}

export function GetNumberFormatHE(valor: number|null, decimalScale:number = 2) {
    if(valor === null){
        return ""
    }
    return (
        <NumberFormat
            value={valor}
            displayType={'text'}
            thousandSeparator={','}
            decimalSeparator={'.'}
            prefix={'$ '}
            decimalScale={decimalScale}
            fixedDecimalScale={true}
        />
    )
}



export default function TablaUnidadesProyeccionHE(props: PropsTablaUnidadesProyeccionHE) {

    const defaultStateModalReversoUnidades: StateModalReversoUnidades = {
        showModal: false,
        cargando: false,
        planificacionUnidad: [],
        observacion: "",
        content: <></>
    };

    const [unidadSeleccionada, setunidadSeleccionada] = useState<UnidadesProyeccion | undefined>(undefined)
    const [unidadDeseaReverso, setunidadDeseaReverso] = useState<UnidadesProyeccion | undefined>(undefined)

    const [motivoReverso, setmotivoReverso] = useState<string>("")
    const [enviarGPE, setenviarGPE] = useState<boolean>(false)
    const [loadingAccion, setloadingAccion] = useState<boolean>(false)

    const [stateModalReversoUnidades, setstateModalReversoUnidades] = useState<StateModalReversoUnidades>(defaultStateModalReversoUnidades)


    const {
        selectedUnidades,
        regimendisponible,
        anioInformacionProyeccion,
        detalleProyeccion



    } = props;

    //PAGES
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(props.defaultRowNumber ?? 5);

    const handleRowsPerPageChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        setRowsPerPage(parseInt(event.target.value));
        setCurrentPage(1); // Reiniciar a la primera página al cambiar el número de filas por página
    };
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;

    //BUSCADOR

    const [searchTerm, setSearchTerm] = useState('');
    const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reiniciar la paginación cuando se busca
    };

    const filteredServidores = selectedUnidades.filter(unid =>
        unid.nombreEstructura.toLowerCase().includes(searchTerm.toLowerCase())
        // actv.estado.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // actv.usuario.toLowerCase().includes(searchTerm.toLowerCase()) ||
        // actv.regimenSiglas.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const [sortColumn, setSortColumn] = useState<string | null>(null);
    const [sortDirection, setSortDirection] = useState('asc');
    const [sortToggle, setSortToggle] = useState(false);



    let currentRows = filteredServidores.slice(indexOfFirstRow, indexOfLastRow);

    const pageNumbers: number[] = [];
    for (let i = 1; i <= Math.ceil(filteredServidores.length / rowsPerPage); i++) {
        pageNumbers.push(i);
    }
    const renderPageNumbers = pageNumbers.map(number => (
        <PaginationItem key={number} active={number === currentPage}>
            <PaginationLink onClick={() => setCurrentPage(number)}>
                {number}
            </PaginationLink>
        </PaginationItem>
    ));

    const handleSort = (column: string) => {
        const isAsc = sortColumn === column && sortDirection === 'asc';
        setSortColumn(column);
        setSortDirection(isAsc ? 'desc' : 'asc');
        setSortToggle(!sortToggle); // Cambia el estado para forzar re-render
    };


    async function OnClickAccionReverso(informacionUnidad: UnidadesProyeccion | undefined) {
        setloadingAccion(true);

        if (!informacionUnidad || !informacionUnidad.detalleSolicitudReverso) {
            setloadingAccion(false);
            await Swal.fire({
                title: 'Advertencia',
                text: 'Información de unidad no válida.',
                icon: 'warning',
                confirmButtonText: 'OK'
            });
            return;
        }

        //const texto = `¿Desea autorizar o negar la solicitud de reverso de ${informacionUnidad.nombreEstructura} ? `
        const texto = `<div class="custom-modal-content">
                            <p>${informacionUnidad.articuloEstructura} <strong>${informacionUnidad.nombreEstructura}</strong> ha solicitado reversar la proyección, por el siguiente motivo:</p>
                            <p>${informacionUnidad.detalleSolicitudReverso.motivoReverso}</p>
                            
                            <p>¿Desea <b>AUTORIZAR</b> o <b>NEGAR</b> la solicitud de reverso?</p>
                            
                        </div>`;

        const { idSolicitudReverso } = informacionUnidad.detalleSolicitudReverso;

        const result = await Swal.fire({
            html: texto,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Autorizar',
            cancelButtonText: 'Negar',
            reverseButtons: true,
            customClass: {
                cancelButton: 'btn-cancelar',
                confirmButton: 'btn-aceptar',
                popup: 'custom-popup'
            },
        });


        if (result.isConfirmed) {
            
            await OnClickAccionSolicitudReverso(1, informacionUnidad);
        } else if (result.isDismissed && result.dismiss === Swal.DismissReason.cancel) {
            await OnClickAccionSolicitudReverso(2, informacionUnidad);
        } else {
            setloadingAccion(false);

            return;
        }

        setloadingAccion(false);

    }

    function TdAccionUnidad(unid: UnidadesProyeccion) {


        if (unid.detalleProyeccionRegimen.length === 0) {
            return <td />
        }


        var classNameNotificacion = "iconAccionTHUnidProyHidden"
        if (unid.detalleSolicitudReverso !== null) {
            classNameNotificacion = "iconAccionTHUnidProy"
        }

        // const estadosAccionesReverso:string[] = [ESTADO_SOLICITADO_REVERSO_A_TH,ESTADO_ENVIADO_A_TH]

        // if (estadosAccionesReverso.includes(unid.estado.trim())) {
        //     return (
        //         <td>
        //             <div className='containerAccionesTHUnidProy'>
        //                 <IconoReversar onClick={() => setunidadSeleccionada(unid)} className="iconAccionTHUnidProy" />
        //                 <IconoNotificacion onClick={() => OnClickAccionReverso(unid)} className={classNameNotificacion} />
        //             </div>
        //         </td>
        //     )
        // } else {
        //     return <td><span><strong>{unid.estadoString}</strong></span></td>
        // }

        if (unid.estado.trim() === ESTADO_ENVIADO_A_TH) {
            return (
                <td>
                    <div className='containerAccionesTHUnidProy'>
                        <IconoReversar onClick={() => setunidadSeleccionada(unid)} className="iconAccionTHUnidProy" />
                    </div>
                </td>
            )
        }
        else if (unid.estado.trim() === ESTADO_SOLICITADO_REVERSO_A_TH) {
            return (
                <td>
                    <div className='containerAccionesTHUnidProy'>
                        <IconoNotificacion onClick={() => OnClickAccionReverso(unid)} className={"iconAccionTHUnidProy"} />
                    </div>
                </td>
            )
        }
        else {
            return <td className='tdEstadoAccionHE'>
                <div className="tdEstadoAccionHE text-center"><strong>{unid.estadoString}</strong></div>
                </td>
        }

    }


    

    function TBodyTablaProyeccionUnidades(currentRows: UnidadesProyeccion[]) {

        const tbody = currentRows.map((unid, idunid) => {



            const presupuestoProyectado = unid.presupuestoProyectado !== null ? GetNumberFormatHE(unid.presupuestoProyectado) : ""
            const presupuestoEjecutado = unid.presupuestoEjecutado !== null ? GetNumberFormatHE(unid.presupuestoEjecutado) : ""
            const presupuestoAsignado = unid.presupuestoAsignado !== null ? GetNumberFormatHE(unid.presupuestoAsignado) : ""

            // if (unid.estado !== ESTADO_ENVIADO_A_TH) {
            //     return (
            //         <React.Fragment key={idunid}>
            //             <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
            //                 <td className="tblProyUnidNombUnid">
            //                     <div>{unid.nombreEstructura}</div>

            //                 </td>
            //                 {
            //                     regimendisponible.map((v, i) => {
            //                         return (
            //                             <React.Fragment key={v.idRegimenLaboral + "vacioNVProyUnTh"}>
            //                                 <td />
            //                                 <td />
            //                             </React.Fragment>

            //                         )
            //                     })
            //                 }
            //                 <td />
            //                 <td />
            //                 <td />
            //                 {
            //                     TdAccionUnidad(unid)
            //                 }
            //             </tr>
            //         </React.Fragment>
            //     )
            // }

            return (
                <React.Fragment key={idunid}>

                    <tr className='rows_tabla_planificacion_he rowsProyeccionUnidadesHE'>
                        <td className="tblProyUnidNombUnid">
                            <div>{unid.nombreEstructura}</div>
                        </td>
                        {
                            unid.detalleProyeccionRegimen.length === 0 && (
                                regimendisponible.map((v, i) => {
                                    return (
                                        <>
                                            <td />
                                            <td />
                                            <td className={"tdValor"}/>
                                        </>

                                    )
                                })
                            )
                        }
                        {
                            unid.detalleProyeccionRegimen.length > 0 && regimendisponible.map((v, i) => {
                                const valorUnidadRegimen = unid.detalleProyeccionRegimen.find(ur => v.idRegimenLaboral === ur.idRegimenLaboral)
                                if (valorUnidadRegimen) {
                                    const totalHoras = valorUnidadRegimen.totalHoras ?? ""
                                    const totalValor = valorUnidadRegimen.valorTotalProyeccion !== null ? GetNumberFormatHE(valorUnidadRegimen.valorTotalProyeccion) : ""
                                    const nroServidores = valorUnidadRegimen.nroServidoresProyectados;
                                    return (
                                        <React.Fragment>
                                            <td className='centrado'>{nroServidores}</td>
                                            <td className='centrado'>{totalHoras}</td>
                                            <td className="tdValor">
                                                <div className='containerValorDinero'>
                                                    {totalValor}
                                                </div>

                                            </td>
                                        </React.Fragment>
                                    )
                                }
                                else {
                                    return (
                                        <>
                                            <td />
                                            <td />
                                            <td className={"tdValor"}/>
                                        </>

                                    )
                                }



                            })
                        }
                        {/* {
                            unid.detalleProyeccionRegimen.length > 0 && unid.detalleProyeccionRegimen.map((v, i) => {
                                
                                const totalHoras = v.totalHoras ?? ""
                                const totalValor = v.valorTotalProyeccion !== null ? v.valorTotalProyeccion.toFixed(2) : ""
                                
                                return (
                                    <React.Fragment>
                                        <td className='centrado'>{totalHoras}</td>
                                        <td>
                                            <div className='containerValorDinero'>
                                                {"$ " + totalValor}
                                            </div>

                                        </td>
                                    </React.Fragment>
                                )
                            })
                        } */}
                        <td className="tdProyectadoProyTH">
                            <div className='containerValorDineroProyectado'>

                                {presupuestoProyectado}
                            </div>

                        </td>
                        <td className="tdEjecutadoProyTH">
                            <div className='containerValorDineroProyectado'>
                                {presupuestoEjecutado}
                            </div>
                        </td>

                        <td className="tdAsignadoProyTH">
                            <div className='containerValorDineroProyectado'>
                                {presupuestoAsignado}
                            </div>
                        </td>



                        {
                            TdAccionUnidad(unid)
                        }

                    </tr>
                </React.Fragment>
            )
        })

        return tbody;
    }

    function TFooterTablaProyeccionUnidades(totalProyeccion: ProyeccionTotal | null) {
        if (totalProyeccion !== null) {
            return (
                <tr className="trFooterUnidadProyectado">
                    <td className="tblProyUnidNombUnid">
                        <div>
                            PRESUPUESTO PROYECTADO {anioInformacionProyeccion.toString()}
                        </div>
                    </td>
                    {
                        totalProyeccion.valorTotalizadoRegimen.filter(v => v.idRegimenLaboral !== 999).map((v, i) => {
                            const nroHoras = v.nroHoras ?? ""
                            const valor = v.valorHoras !== null ? GetNumberFormatHE(v.valorHoras) : "";
                            const nroServidores = v.nroServidoresProyectados
                            return (
                                <React.Fragment key={"valorProyUnidades " + i}>
                                     <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroServidores} </td>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"}> {nroHoras} </td>
                                    <td key={v.idRegimenLaboral + "tdVacioValor"}>
                                        <div className='containerValorDinero'>
                                            {valor}
                                        </div>
                                    </td>
                                </React.Fragment>
                            )
                        })
                    }
                    <td>
                        <div className='containerValorDineroProyectado'>
                            {totalProyeccion.valorTotalProyeccionActual != null ? GetNumberFormatHE(totalProyeccion.valorTotalProyeccionActual) : ""}

                        </div>

                    </td>
                    <td>
                        <div className='containerValorDineroProyectado'>
                            {totalProyeccion.valorTotalEjecutadoAnioAnterior != null ? GetNumberFormatHE(totalProyeccion.valorTotalEjecutadoAnioAnterior) : ""}

                        </div>
                    </td>
                    <td>
                        <div className='containerValorDineroProyectado'>
                            {totalProyeccion.valorTotalPresupuestoAsignado != null ? GetNumberFormatHE(totalProyeccion.valorTotalPresupuestoAsignado) : ""}
                        </div>
                    </td>
                    <td />
                </tr>
            )
        }
        else {
            return (
                <tr>
                    <td> PRESUPUESTO PROYECTADO {anioInformacionProyeccion.toString()}</td>
                    {
                        props.regimendisponible.map((v, i) => {
                            return (
                                <React.Fragment>
                                    <td key={v.idRegimenLaboral + "tdVacioNro"} />
                                    <td key={v.idRegimenLaboral + "tdVacioValor"} />
                                </React.Fragment>
                            )
                        })
                    }
                    <td colSpan={4} />
                </tr>
            )
        }
    }

    function AuxiliarGenerarHTMLBodyModalReversarPlanificacion(proyecciones: UnidadesProyeccion[]) {

        const contentBody = (
            <>

                <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                    <thead className="cabecerasDetallehistorialSolic">
                        <tr className="" >
                            <th> Unidad</th>

                        </tr>
                    </thead>
                    <tbody>
                        {proyecciones.map((proy, ind) => {
                            return (
                                <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                    <td className="">
                                        <div className="">
                                            {proy.nombreEstructura}
                                        </div>

                                    </td>

                                </tr>
                            )
                        })}
                    </tbody>
                </Table>

            </>

        )

        return contentBody;
    }

    function OnClickAccionReversarUnidades(proyecciones: UnidadesProyeccion[]) {

        const estadosReverso:string[] = [ESTADO_ENVIADO_A_TH,ESTADO_SOLICITADO_REVERSO_A_TH];

        var planificacionesUnidades = proyecciones.filter(p => p.detalleProyeccionRegimen.length > 0 && estadosReverso.includes(p.estado.trim()))

        if (planificacionesUnidades && planificacionesUnidades.length > 0) {
            var content = AuxiliarGenerarHTMLBodyModalReversarPlanificacion(planificacionesUnidades)
            setstateModalReversoUnidades({
                showModal: true,
                cargando: false,
                planificacionUnidad: planificacionesUnidades,
                observacion: "",
                content
            })
        }
        else {
            showAlertAviso("No hay proyecciones con estado ingresada o que hayan solicitado reverso")
        }


    }


    const ReversarUnidad = useCallback(
        async (unidad: UnidadesProyeccion | undefined, observacion: string) => {

            if (unidad === undefined) {
                return -1
            }

            const unidadReverso: ReversarUnidadProyeccionHEDTO = {
                unidades: [
                    unidad.idEstructuraOrganica
                ],
                motivo: motivoReverso
            }

            const respuesta = await ReversarUnidadDesdeTH(unidadReverso)
            if (respuesta.status === 200) {
                showAlert("La proyección de la unidad " + unidad.nombreEstructura + " ha sido reveresada" , true)
                await props.onActualizarTabla()
                return 1

            }
            else {
                showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
                return -1
            }
        },
        [motivoReverso],
    )

    async function ReversarProyeccionesUnidades(proyecciones: UnidadesProyeccion[], observacion: string) {
        if (proyecciones === undefined || proyecciones.length === 0) {
            return -1
        }

        const unidades: number[] = proyecciones.map((v, i) => { return v.idEstructuraOrganica })

        const postReverso: ReversarUnidadProyeccionHEDTO = {
            unidades: unidades,
            motivo: observacion
        }

        const respuesta = await ReversarUnidadDesdeTH(postReverso)
        if (respuesta.status === 200) {
            showAlert("Se ha reversado la proyección de las unidades", true)
            await props.onActualizarTabla()
            return 1

        }
        else {
            showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
            return -1
        }

    }

    async function EnvioProyeccionesGPE() {

        const respuesta = await EnviarProyeccionesUnidadesAGPE(detalleProyeccion.idPeriodoProyeccion);

        if (respuesta.status === 200) {
            showAlert("Las proyecciones han sido enviadas a Gerencia de Planificación Estratégica", true)
            await props.onActualizarTabla()
            return 1
        }
        else {
            showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);
            return -1
        }


    }

    async function ReportePDF() {
        setloadingAccion(true)
        await ObtenerReporteProyeccionesUnidadesTH(props.detalleProyeccion.idPeriodoProyeccion,"TH")
        setloadingAccion(false)
    }

    async function ReporteExcel() {
        setloadingAccion(true)
        await ObtenerReporteExcelProyeccionesUnidadesTH(props.detalleProyeccion.idPeriodoProyeccion,"TH")
        setloadingAccion(false)
    }

    async function OnClickAccionSolicitudReverso(tipoAccion: 1 | 2, informacionUnidad: UnidadesProyeccion | undefined) {
        setloadingAccion(true)

        if (informacionUnidad && informacionUnidad.detalleSolicitudReverso) {
            const infoSolicitud: AtenderSolicitudReverso = {
                idSolicitudReverso: informacionUnidad.detalleSolicitudReverso.idSolicitudReverso,
                tipoAccion: tipoAccion
            }

            const respuesta = await PutAtenderSolicituReverso(infoSolicitud);

            const textoAutorizacion = tipoAccion === 1 ? "AUTORIZADA" : tipoAccion === 2 ? "NEGADA" : ""

            if (respuesta.status === 200) {
                showAlert("La solicitud de reverso de proyección ha sido " + textoAutorizacion, true)
                await props.onActualizarTabla()

            }
            else {
                showAlert(respuesta.errorMessage ?? "Ha ocurrido un inconveniente", false);

            }
        }

        setloadingAccion(false)
    }





    const contenidoModalReversarUnidad = useMemo(
        () => {
            if (unidadSeleccionada !== undefined) {
                return (
                    <React.Fragment>
                        <Row>
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>

                                    </Col>
                                    <Col xl={12}>
                                        <Input
                                            type="textarea"
                                            name="motivoReversoUnidadProy"
                                            id="motivoReversoUnidadProy"
                                            value={motivoReverso}
                                            onChange={(e) => setmotivoReverso(e.target.value)}
                                        />
                                    </Col>

                                </Row>
                            </Col>
                        </Row>

                    </React.Fragment>

                )
            }
            else {
                return (
                    <div> No se ha seleccionado actividad para editar </div>
                )
            }
        },
        [motivoReverso, unidadSeleccionada],
    )

    const contenidoModalReversarUnidades = useMemo(
        
        () => {
            if(stateModalReversoUnidades && stateModalReversoUnidades.planificacionUnidad.length > 0){
                return (
                    <React.Fragment>
                        <Row>
    
                            <Col xl={12}>
                                <Row>
                                    <Col xl={12}>
                                        <span className={"labelReversoUnidadProyeccion"}> Motivo de reverso</span>
    
                                    </Col>
                                    <Col xl={12}>
                                        <Input
                                            type="textarea"
                                            name="motivoReversoUnidadProy"
                                            id="motivoReversoUnidadProy"
                                            value={motivoReverso}
                                            onChange={(e) => setmotivoReverso(e.target.value)}
                                        />
                                    </Col>
    
                                </Row>
                            </Col>
                        </Row>
                        
    
                    </React.Fragment>
    
                )
            } else{
                return (
                    <div> No tiene unidades para reversar </div>
                )
            }
            
        },
        [motivoReverso, stateModalReversoUnidades],
    ) 

    const contenidoModalEnviarGPE = () => {
        return (
            <React.Fragment>
                <Row>
                    <Col>
                        <div className="textModalEnviarAGPE">
                            {"¿DESEA ENVIAR A GERENCIA DE PLANIFICACIÓN ESTRATÉGICA LA PROYECCIÓN ANUAL DE HORAS EXTRAS?"}
                        </div>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }




    return (

        <React.Fragment>
            <Row className="justify-content-end">
                <Col xl={6}>
                    <div className='containerBotonesTablaProyUnid'>
                        <Button
                            onClick={() => OnClickAccionReversarUnidades(currentRows)}
                            className="btn-white-lightblueborder "
                        >
                            <div className="containerBotonImprimir">
                                <div>Regresar Todas</div>
                                <IconoReversar className="iconBotonImprimir" />
                            </div>
                        </Button>
                        <Button
                            onClick={() => ReportePDF()}
                            className="btn-white-lightblueborder "
                            disabled={loadingAccion}
                        >
                            <div className="containerBotonImprimir">
                                <div>Imprimir Resumen</div>
                                <IconoImprimir className="iconBotonImprimir" />
                            </div>
                        </Button>

                        <Button onClick={() => setenviarGPE(true)} className="btn-white-lightblueborder ">Notificar a GPE</Button>

                        <Button
                            disabled={loadingAccion}
                            onClick={() => ReporteExcel()}
                            className="btn-Excel "
                        >
                            <div className="containerBotonImprimir">
                                <div>Exportar a Excel</div>
                                <IconoExcel className="iconBotonImprimir" />
                            </div>
                        </Button>


                    </div>

                </Col>
            </Row>
            <Row>
                <Col md="9">
                    <div className="d-flex align-items-center justify-content-start">
                        <Label for="rowsPerPageSelect" className="mb-0 mr-2">Mostrar</Label>
                        <select
                            id="rowsPerPageSelect"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="custom-select custom-select-sm mr-2" // Ajusta el tamaño del select
                            style={{ width: 'auto' }} // Asegura que el select no tome más espacio del necesario
                        >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                        </select>
                        <Label className="mb-0">filas</Label>
                    </div>
                </Col>
                <Col md="3">
                    <Input
                        type="text"
                        placeholder="Buscar..."
                        value={searchTerm}
                        onChange={handleSearchChange}
                        className="form-control-sm" // Reduce el tamaño del input
                    />
                </Col>
            </Row>
            <Table responsive bordered className="table_planificacion_he">
                <thead className="cabeceras_tabla_proyeccionTH_he">
                    <tr className="borde_cabeceras_he">
                        <th className="thUnidad" rowSpan={2} onClick={() => handleSort('nombreEstructura')}>Unidad</th>
                        {
                            regimendisponible.map((v, i) => {
                                return (
                                    <th className="thSiglasRegimenLaboral" colSpan={3}> {v.siglasRegimenLaboral}</th>
                                )
                            })
                        }
                        <th className="thPresupuestosProyUn" rowSpan={2} > 
                            <span> PRESUPUESTO </span>
                            <br/>
                            <span> {` PROYECTADO ${anioInformacionProyeccion}`} </span>
                        </th>
                        <th className="thPresupuestosProyUn" rowSpan={2} > 
                            <span> PRESUPUESTO </span>
                            <br/>
                            <span>{` EJECUTADO ${anioInformacionProyeccion - 1}`}  </span>
                            
                        </th>
                        <th className="thPresupuestosProyUn" rowSpan={2} > 
                            <span> PRESUPUESTO </span>
                            <br/>
                            <span> ASIGNADO </span>
                        </th>
                        <th className="thAccionesProyUn" rowSpan={2} > {`Acciones`}</th>
                    </tr>
                    <tr>
                        {
                            regimendisponible.map((v, i) => {
                                return (
                                    <React.Fragment>
                                        <th>
                                            <span>Num. </span>
                                            <br/>
                                            <span>Servidores</span>
                                            
                                        </th>
                                        <th>
                                            <span>Num. </span>
                                            <br/>
                                            <span>Horas</span>
                                             
                                        </th>
                                        <th className="thValorRegimenProyUn">
                                            Valor
                                        </th>
                                    </React.Fragment>

                                )
                            })
                        }
                        {/* {
                            regimendisponible.map((v, i) => {
                                return (
                                    <React.Fragment>
                                        <th>
                                            {v.siglasLetrasRegimenLaboral}
                                        </th>
                                    </React.Fragment>

                                )
                            })
                        } */}
                    </tr>
                </thead>
                <tbody>
                    {TBodyTablaProyeccionUnidades(currentRows)}
                </tbody>
                <tfoot id="footTablaProyeccionUnidadesTH">
                    {TFooterTablaProyeccionUnidades(props.totalProyeccion)}
                </tfoot>

            </Table>
            <Pagination size="sm" className="pagination_planificacion_he">
                {renderPageNumbers}
            </Pagination>


            <div style={{ display: "flex", justifyContent: "center" }}>
                <Button onClick={() => setenviarGPE(true)} className="btn-white-lightblueborder ">Notificar a GPE</Button>

            </div>





            <ModalConfirmacion
                idModal='ModalReversoUnidadesTHHE'
                backdrop={false}
                show={unidadSeleccionada !== undefined}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
                disabledBotonAccion={!motivoReverso}
                // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
                onClose={() => setunidadSeleccionada(undefined)}
                asyncOnClick={() => ReversarUnidad(unidadSeleccionada, "")}
                contentModal={contenidoModalReversarUnidad}
                classNameContentModal='modalContentReversoTHHE'
                tituloModal={"Reverso unidad " + unidadSeleccionada?.nombreEstructura}
                classNametituloModal=''
            />

            <ModalConfirmacion
                idModal='ModalReversoUnidadesTHHE'
                backdrop={false}
                show={(stateModalReversoUnidades.showModal === true ) || stateModalReversoUnidades.cargando}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                closeAfterAccion={true}
                hideBotonCerrar={true}
                mensajeConfirmacion=''
                nombreBotonAccion='Aceptar'
                classNameBotonAccion='btn-primary-new btnAceptarModalReversoTHHE'
                disabledBotonAccion={!motivoReverso}
                // <Button  className = "btn-primary-new" color="primary" title="Asignar Servidores" onClick={toggleModal}>Asignar a:</Button>
                onClose={() => setstateModalReversoUnidades(defaultStateModalReversoUnidades)}
                asyncOnClick={() => ReversarProyeccionesUnidades(stateModalReversoUnidades.planificacionUnidad, motivoReverso )}
                contentModal={contenidoModalReversarUnidades}
                classNameContentModal='modalContentReversoTHHE'
                tituloModal={"Reversar la proyección de las unidades " }
                classNametituloModal=''
            />  
{/* 
            <ModalReversoHE
                show={unidadSeleccionada !== undefined}
                size="lg"
                onClose={() => setunidadSeleccionada(undefined)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea reversar la proyección de esta unidad?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => ReversarUnidad(unidadSeleccionada, observacion)}
                contentModal={undefined}
                tituloModal={"Reversar la proyección de la unidad"}
                labelObservacion={"Indique el motivo del reverso"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}
            /> */}

            {/* {
                stateModalReversoUnidades &&
                <ModalReversoHE
                    show={stateModalReversoUnidades.showModal === true || stateModalReversoUnidades.cargando}
                    size="lg"
                    onClose={() => setstateModalReversoUnidades(undefined)}
                    asyncAccion={true}
                    asyncClose={true}
                    closeAfterAccion={true}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={"¿Está seguro/a que desea reversar todas las proyecciones?"}
                    nombreBotonAccion={"SI"}
                    nombreBotonCerrarModal={"NO"}
                    asyncOnClick={(observacion) => ReversarProyeccionesUnidades(stateModalReversoUnidades.planificacionUnidad, observacion)}
                    contentModal={stateModalReversoUnidades.content}
                    tituloModal={"Reversar la planificación de las unidades"}
                    labelObservacion={"Indique el motivo del reverso"}
                    botonesAccionParteSuperior={true}
                    classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                    maxLength={500}

                />

            } */}

            <ModalConfirmacion
                idModal='ModalEnviarGPEUnidadesTH'
                show={enviarGPE}
                size='lg'
                centered={true}
                asyncAccion={true}
                asyncClose={false}
                asyncOnClick={() => EnvioProyeccionesGPE()}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                nombreBotonCerrarModal='CANCELAR'
                mensajeConfirmacion=''
                nombreBotonAccion='ACEPTAR'
                classNameBotonAccion="btnEspolPrimary"
                classNameBotonCerrarModal2={"btn-white-red"}
                onClose={() => setenviarGPE(false)}
                contentModal={contenidoModalEnviarGPE()}
                tituloModal=''
                invertOrderButton={true}
                noModalHeader={true}


            />

            {/* <ModalReversarUnidad
                show={unidadDeseaReverso !== undefined}
                informacionSolReverso={unidadDeseaReverso}
                onClose={() => setunidadDeseaReverso(undefined)}
                onClickAceptar={() => OnClickAccionSolicitudReverso(1, unidadDeseaReverso)}
                onClickNegar={() => OnClickAccionSolicitudReverso(2, unidadDeseaReverso)}

            /> */}




            <ModalCargando
                show={loadingAccion}
                onClose={() => setloadingAccion(false)}
                size='md'
            />


        </React.Fragment>

    )
}
